import FacturesTabulatorController from './factures-tabulator.controller';
import FactureTabulatorTpl from './factures-tabulator.tpl.html';

export default {
	template: FactureTabulatorTpl,
	controller: FacturesTabulatorController
};
